import { render, staticRenderFns } from "./valuecode.vue?vue&type=template&id=9ec50a12&"
import script from "./valuecode.vue?vue&type=script&lang=js&"
export * from "./valuecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports